(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('timeResolutionSelector', ["path", "timeResolutions", function (path, timeResolutions) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('dashboard/time-resolution-selector').template('time-resolution-selector'),
            scope: { resolution: '=' },
            link: function ($scope, element, attrs) {
                $scope.variants = _(timeResolutions.dataPastLabel).filter(function (item) {
                    item.autoId = 'dashboard_time_resolution_dropdown_item_' + item.id;
                    return item.id !== 'minute' && item.id !== 'hour';
                });
            }
        };
    }]);
}());